jQuery('.hakuehto-toggle-container').click(function() {
    jQuery('.hakuehto-toggle-container').toggleClass('open');
    jQuery('.vaihtoauto__filters-container').toggleClass('open');
});

jQuery(window).on('load', function() {
    if(readCookie('priceselection') == 'kk') {
        monthlyPrice();
    }
    if(readCookie('priceselection') == 'full') {
        normalPrice();
    }

    (function($) {
        $(document).on('facetwp-loaded', function() {
            if (FWP.loaded) {
                $('html, body').animate({
                    scrollTop: $('.hakuehto-toggle-container').offset().top
                }, 400);
            }
        });
    })(jQuery);
});

jQuery('.choose-price div').click(function() {
    if( jQuery( this ).data('hinta') == 'full') {
        document.cookie = "priceselection="+jQuery( this ).data('hinta')+";";
        normalPrice();
    } 
    if( jQuery( this ).data('hinta') == 'kk') {
        document.cookie = "priceselection="+jQuery( this ).data('hinta')+";";
        monthlyPrice();
    }
});

function normalPrice() {
    jQuery('.choose-price .normalprice').addClass('selected');
    jQuery('.choose-price .monthlyprice').removeClass('selected');
    jQuery('.price-filter-container').addClass('full');
    jQuery('.price-filter-container').removeClass('kk');
    jQuery('.vaihtoauto-card').each(function() {
        jQuery(this).find('.card-link .car-info-container .hinta-container .kokonais').text('Hinta');
        jQuery(this).find('.card-link .car-info-container .hinta-container .alkaen').text('Alk.');
        jQuery(this).find('.card-link .car-info-container .hinta-container .rahoitus').text(jQuery(this).data('fullprice'));
        jQuery(this).find('.card-link .car-info-container .hinta-container .car-hinta').text(jQuery(this).data('monthlyprice'));
    });
}

function monthlyPrice() {
    jQuery('.choose-price .monthlyprice').addClass('selected');
    jQuery('.choose-price .normalprice').removeClass('selected');
    jQuery('.price-filter-container').addClass('kk');
    jQuery('.price-filter-container').removeClass('full');
    jQuery('.vaihtoauto-card').each(function() {
        jQuery(this).find('.card-link .car-info-container .hinta-container .kokonais').text('Alk.');
        jQuery(this).find('.card-link .car-info-container .hinta-container .alkaen').text('Hinta');
        jQuery(this).find('.card-link .car-info-container .hinta-container .rahoitus').text(jQuery(this).data('monthlyprice'));
        jQuery(this).find('.card-link .car-info-container .hinta-container .car-hinta').text(jQuery(this).data('fullprice'));
    });
}

(function($) {
    document.addEventListener('facetwp-loaded', function() {
        if(readCookie('priceselection') == 'kk') {
            monthlyPrice();
        }
        if(readCookie('priceselection') == 'full') {
            normalPrice();
        }
    });
})(jQuery);

document.addEventListener('facetwp-refresh', function() {
    if(readCookie('priceselection') == 'kk') {
        monthlyPrice();
    }
    if(readCookie('priceselection') == 'full') {
        normalPrice();
    }
});

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}